import {
  LIVE_CLASS_LIST_FAILED,
  LIVE_CLASS_LIST_REQ,
  LIVE_CLASS_LIST_SUCCESS,
} from "../Constant/LiveClassConstant";
import api from "../Core/api";

export const list_LiveClass = () => async (dispatch) => {
  try {
    dispatch({ type: LIVE_CLASS_LIST_REQ });
    const { data } = await api.get("/student/studybatch/liveclass");
    dispatch({
      type: LIVE_CLASS_LIST_SUCCESS,
      payload: data?.Classes,
      MeetingData: data?.MeetingData,
      DemoClasses: data?.DemoClasses,
    });
  } catch (error) {
    dispatch({
      type: LIVE_CLASS_LIST_FAILED,
      payload:
        error.response && error?.response?.data?.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const Record_Class = (packageId) => async (dispatch) => {
  try {
    dispatch({ type: LIVE_CLASS_LIST_REQ });
    const { data } = await api.get(`/student/recordedclass/${packageId}`);
    dispatch({
      type: LIVE_CLASS_LIST_SUCCESS,
      payload: data?.Result,
 
    });
  } catch (error) {
    dispatch({
      type: LIVE_CLASS_LIST_FAILED,
      payload:
        error.response && error?.response?.data?.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
